module.exports = __webpack_public_path__ + "img/artifactory.a47014a9.png";